import {useEffect, useRef} from 'react';

const usePreventScrollOnDrag = (isDragging) => {
  const scrollPos = useRef({x: 0, y: 0});

  useEffect(() => {
    const preventDefault = (e) => e.preventDefault();
    const preventScroll = () =>
      window.scrollTo(scrollPos.current.x, scrollPos.current.y);

    if (isDragging) {
      scrollPos.current = {x: window.scrollX, y: window.scrollY};

      window.addEventListener('wheel', preventDefault, {passive: false});
      window.addEventListener('touchmove', preventDefault, {passive: false});
      window.addEventListener('scroll', preventScroll, {passive: false});

      document.body.style.WebkitUserSelect = 'none';
    }

    return () => {
      window.removeEventListener('wheel', preventDefault);
      window.removeEventListener('touchmove', preventDefault);
      window.removeEventListener('scroll', preventScroll);

      document.body.style.WebkitUserSelect = ''; // 원상복구
    };
  }, [isDragging]);
};

export default usePreventScrollOnDrag;
